import { UUID } from "crypto";

/**
 * Client group query key factory
 */
export const clientGroupKeys = {
  all: ["clientGroups"] as const,
  lists: () => [...clientGroupKeys.all, "list"] as const,
  list: () => [...clientGroupKeys.lists()] as const,
  details: () => [...clientGroupKeys.all, "detail"] as const,
  detail: (id: UUID) => [...clientGroupKeys.details(), id] as const,
  partnerGroups: (partnerId: UUID) =>
    [...clientGroupKeys.all, "partner", partnerId] as const,
} as const;
